module.exports = __webpack_public_path__ + "static/media/sparklingphoto.537057ed.jpg";